import InternationalEnum from "@src/Locales/Constants/InternationalEnum";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface IImagesProps {
  src: string;
  alt?: string;
}

interface IReturnRes {
  home: IImagesProps[];
  qrorder: IImagesProps[];
  reservas: IImagesProps[];
  cartaDigital: IImagesProps[];
  tpv: IImagesProps[];
  backOffice: IImagesProps[];
  member: IImagesProps[];
  marketing: IImagesProps[];
  rsInsightAPP: IImagesProps[];
  kds: IImagesProps[];
  quioscos: IImagesProps[];
  restoPara: IImagesProps[];
  sobreNosotros: IImagesProps[];
  tarifas: IImagesProps[];
  contact: IImagesProps[];
  gestionyControl: IImagesProps[];
  delivery: IImagesProps[];
  download: IImagesProps[];
  elecMenu: IImagesProps[];
  globalService: IImagesProps[];
}

type ICurrimages = {
  [K in keyof IReturnRes]: IImagesProps[];
};

type IImageKey = keyof IReturnRes;

const useImagesLanguage = () => {
  const { t, i18n } = useTranslation();

  const transformImagesFillProps = (currImages: ICurrimages) => {
    return Object.entries(currImages)?.reduce((pre, o) => {
      const [key, value] = o;
      pre[key as IImageKey] = value?.map((item) => ({
        ...item,
        alt: t(InternationalEnum.imageLoadingFailed, { ns: "InternationalWebsite" }),
      }));
      return pre;
    }, {} as IReturnRes);
  };

  const getImagesSrcs = (prefix: string, name: string, count: number) => {
    const namePrefix = i18n.language === "en_us" ? "en" : "es";
    const imagesCounts = new Array(count)?.fill(1)?.map((o, index) => {
      try {
        return {
          src: require("../../../assets/international/" +
            `${prefix}/` +
            `${namePrefix}-${name}-${index + 1}` +
            ".png"),
        };
      } catch (e) {
        // 兜底走es图片
        return {
          src: require("../../../assets/international/" +
            `${prefix}/` +
            `${"es"}-${name}-${index + 1}` +
            ".png"),
        };
      }
    });
    return imagesCounts;
  };

  const esImagesUnion = (): IReturnRes => {
    return {
      home: getImagesSrcs("home", "home", 54),
      qrorder: getImagesSrcs("qrOrder", "qrorder", 31),
      reservas: getImagesSrcs("reservas", "reservas", 16),
      cartaDigital: getImagesSrcs("cartaDigital", "carta", 10),
      tpv: getImagesSrcs("tpv", "tpv", 18),
      backOffice: getImagesSrcs("backOffice", "backoffice", 42),
      member: getImagesSrcs("member", "member", 19),
      marketing: getImagesSrcs("marketing", "marketing", 21),
      rsInsightAPP: getImagesSrcs("rsInsightApp", "rsInsightApp", 13),
      kds: getImagesSrcs("kds", "kds", 16),
      quioscos: getImagesSrcs("quioscos", "quioscos", 11),
      restoPara: getImagesSrcs("restoPara", "para", 15),
      sobreNosotros: getImagesSrcs("sobreNosotros", "sobre", 24),
      tarifas: getImagesSrcs("tarifas", "tarifas", 5),
      contact: getImagesSrcs("contact", "contact", 5),
      gestionyControl: getImagesSrcs("gestionyControl", "gestionyControl", 35),
      delivery: getImagesSrcs("deliveryUnionTakeout", "delivery", 15),
      download: getImagesSrcs("downLoadCenter", "download", 12),
      elecMenu: getImagesSrcs("electricMenu", "menu", 6),
      globalService: getImagesSrcs("globalService", "service", 3),
    };
  };

  const res = useMemo(() => {
    return transformImagesFillProps(esImagesUnion());
  }, [i18n.language]);

  return res;
};

export default useImagesLanguage;
